// extracted by mini-css-extract-plugin
export default {"glance":"glance_glance__Cuo2+","header":"glance_header__FQTjQ"};